<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Grouping Admin</span>
      </v-card-title>

      Must login as ADMIN to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isAdmin() && $AuthSvc.isLogin() && registerTournaments.length > 1">
      <v-card-text v-if="registerTournaments !== null && registerTournaments.length > 1">
        <v-card-title>
          Select course for registration list:
        </v-card-title>

        <v-card-text>
          <div v-for="tn in registerTournaments" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
            <div class="select-btn" @click="selectTournament(tn)">
              <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                {{printDateTime(tn.tournament.scheduleDate)}}
              </span>
              <span style="display:inline-block;padding-top:7px;text-align:left;">
                {{tn.course!==null?tn.course.name:''}}
              </span>
              <span> ({{tn.tournament.formatType}}) </span>
            </div>
          </div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <v-card class="main-card">
      <v-card-text class="left-card" v-if="$AuthSvc.isLogin() && tournament !== null">
        <v-card-title style="padding-bottom:0">
          <span class="page-title">Grouping Admin</span>
        </v-card-title>

        <v-card-text>
          <span >{{course!==null?course.name:''}} - {{tournament != null ? tournament.formatType : ''}}</span>
        </v-card-text>

        <v-card-text>
          <a v-bind:href="'/public/tournaments/' + tournament.tournamentId + '/registrations-csv'">
            Tournament Group CSV file
          </a>
        </v-card-text>

        <v-card-text style="width:100%;margin-bottom:20px;margin-top:20px; background-color:none;">
          <v-btn class="action-btn" @click="savePlayers()">Save</v-btn>
          <v-btn class="action-btn" @click="autoGenerate()">Gen</v-btn>
          <v-btn class="action-btn" @click="autoGenerateEW()">Gen E/W</v-btn>
          <v-btn class="action-btn" @click="clearPairing()">Clear</v-btn>
        </v-card-text>

        <v-card-text class="main-view">
          <v-card-text class="group-table-card">
            <v-simple-table class="simple-table">
              <tr>
                <th width="5px">#</th>
                <th>Name</th>
                <th>Loc</th>
                <th>Flight</th>
                <th width="10px">Grp</th>
              </tr>
              <tr v-if="noGroups !== null && noGroups.length === 0">
                <td></td>
                <td>No Players</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr v-for="(player, index) in noGroups" :key="player.playerId"
                  class="playerRow"
              >
                <td :class="{a_team: player.team === 'B'}">{{index+1}}</td>
                <td :class="{a_team: player.team === 'B'}">{{getName(player)}}</td>
                <td :class="{a_team: player.team === 'B'}">{{player.proximity !== null ? player.proximity.charAt(0) : ""}}</td>
                <td :class="{a_team: player.team === 'B'}">{{player.flight}}</td>
                <td :class="{a_team: player.team === 'B'}"><input type="text" class="group" @change="change(player)" v-model="player.groupId"/></td>
              </tr>
            </v-simple-table>
          </v-card-text>

          <v-card-text class="group-cards">
            <div class="card-div"
                 v-for="(group, index) in groups" :key="group">

              <v-simple-table class="simple-table">
                <tr>
                  <th width="5px">
                    <input type="checkbox" style="width:20px;height:20px" v-model="group.matchPlay" @change="toggleMatchPlay(group)">
                  </th>
                  <th width="5px">Id</th>
                  <th>
                    Group: {{index+1}}
                    <input class="teebox-input" type="text" v-model="group.teeBox">
                    <a style="color: gold" class="label12" @click="scoreCard(index+1, group.players[0].playerId)">ScoreCard</a>
                  </th>
                  <th width="10px">Loc</th>
                  <th width="10px">HCP</th>
                  <th width="10px">DEL</th>
                </tr>
                <tr v-for="(player, idx) in group.players" :key="player.playerId">
                  <td :class="{a_team: player.team === 'B'}">
                    <input style="width:20px;padding:1px 3px" type="text" v-model="player.team">
                  </td>
                  <td :class="{a_team: player.team === 'B'}">
                    <input style="width:20px;padding:1px 3px" type="text" v-model="player.ateam">
                  </td>
                  <td :class="{a_team: player.team === 'B'}" @click="toggleTeam(player, index, idx)">{{getName(player)}}</td>
                  <td :class="{a_team: player.team === 'B'}" @click="toggleTeam(player, index, idx)">{{player.proximity !== null ? player.proximity.charAt(0) : ""}}</td>
                  <td :class="{a_team: player.team === 'B'}" @click="toggleTeam(player, index, idx)">{{$AuthSvc.getHcp(player.handicap)}}</td>
                  <td :class="{a_team: player.team === 'B'}"><input type="checkbox" class="checkbox" v-model="player.del"/></td>
                </tr>
              </v-simple-table>
            </div>
          </v-card-text>
        </v-card-text>
      </v-card-text>

    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

export default {
  name: "login",
  data: () => ({
    count: 0,
    noGroups: null,
    groups: null,
    tournament: null,
    course: null,
    registerTournaments: [],
  }),
  mounted: function() {
    this.$AuthSvc.authenticated(this.load);
  },
  methods: {
    load() {
      var _this = this;

      _this.tournament = null;
      _this.course == null;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
          if (data !== null) {
            _this.tournament = data.tournament;
            _this.course = data.course;
            _this.loadPlayers(_this.tournament);
          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/ADMIN_PAIRINGS', function(data) {
          _this.registerTournaments = data;
          if (data !== null && data.length === 1) {
            _this.course = data[0].course;
            _this.tournament = data[0].tournament;
            _this.loadPlayers(_this.tournament);
          }
        });
      }
    },
    scoreCard(groupId, playerId) {
      window.location.href = '/scoring?id=' + this.tournament.tournamentId + '&playerId=' + playerId;
    },
    loadPlayers(tournament) {
      var _this = this;

      this.axios.get('/public/scores/score-card/group/' + tournament.tournamentId)
          .then(function (response) {
            var i;
            var players = response.data;

            var size = 0;
            for(i=0; i < players.length; i++) {
              if (players[i].groupId > size) {
                size = players[i].groupId;
              }
            }

            _this.noGroups = new Array();
            _this.groups = new Array(size);

            for(i=0; i < size; i++) {
              _this.groups[i] = {
                groupId: i+1,
                teeBox: null,
                players: new Array()
              }
            }

            for(i=0; i < players.length; i++) {
              const gId = players[i].groupId;
              players[i].del = false;
              if (gId === 0) {
                _this.noGroups.push(players[i]);
              }
              else if (gId > 0) {
                _this.groups[gId-1].teeBox = players[i].teeBox;
                _this.groups[gId-1].players.push(players[i]);
                if (_this.groups[gId-1].players.length === 1) {
                  _this.groups[gId-1].matchPlay = players[i].matchPlay === 'Y';
                }
              }
            }

            _this.noGroups.sort((a, b) => {
              if ( a.firstName < b.firstName ) {
                return -1;
              }
              else {
                return 1;
              }
            });
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
          });
    },
    getName(player) {
      if (player !==  null && player.firstName !== undefined) {
        return player.firstName + " " +  this.$AuthSvc.firstChar(player.middleName) + " " + player.lastName;
      }
      return "";
    },
    change(player) {
      console.log('CHANGE: ' + player.playerId);
    },
    clearPairing() {
      var _this = this;

      swal({
        title: "Are you sure?",
        text: "Once cleared, you cannot recover!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          var savedPlayers = new Array();

          for(var i=0; i < _this.groups.length; i++) {
            for(var j=0; j < _this.groups[i].players.length; j++) {
              var player = _this.groups[i].players[j];
              player.groupId = 0;
              player.team = '';
              player.ateam = '';
              player.matchPlay = 'N';
              player.teeBox = '';
              savedPlayers.push(player);
            }
          }

          _this.saveAll(savedPlayers);
        }
      });
    },
    printDateTime(date) {
      return moment(date).format('MM/DD hh:mm A');
    },
    toggleTeam(player, groupIdx, playerIdx) {
      var _this = this;
      var _groupIdx = groupIdx;
      var _playerIdx = playerIdx;

      var tm = (player.team === 'A'? 'B':'A');

      var scoreCard = {
        scoreCardId: player.scoreCardId,
        team: tm
      }

      _this.axios.post('/api/scores/toggle-team/', scoreCard)
          .then(function (response) {
            _this.groups[_groupIdx].players[_playerIdx].team = tm;
            _this.groups[_groupIdx].players[_playerIdx].ateam = player.ateam;
            console.log('TEAM RESPONSE: ' + response);
            _this.loadPlayers(_this.tournament);
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
          });
    },
    toggleMatchPlay(group) {
      for(var i=0; i < group.players.length; i++) {
        group.players[i].matchPlay = group.matchPlay ? 'Y' : 'N';
      }

      this.saveAll(group.players);
    },
    selectTournament(tn) {
      this.course=tn.course;
      this.tournament = tn.tournament;
      window.location.href = "/grouping-admin?id=" + tn.tournament.tournamentId;
    },
    savePlayers() {
      var _this = this;
      var savedPlayers = new Array();

      var i, j;
      for(i=0; i < _this.noGroups.length; i++) {
        if (_this.noGroups[i].groupId === 0) {
          _this.noGroups[i].team = '';
          _this.noGroups[i].ateam = '';
          _this.noGroups[i].matchPlay = 'N';
          _this.noGroups[i].teeBox = '';
        }
        savedPlayers.push(_this.noGroups[i]);
      }

      for(i=0; i < _this.groups.length; i++) {
        for(j=0; j < _this.groups[i].players.length; j++) {
          var player = _this.groups[i].players[j];
          player = _this.assignPlayer(_this.groups[i], player, j);

          if (_this.groups[i].matchPlay) {
            player.matchPlay = 'Y';
          }
          else {
            player.matchPlay = 'N';
          }

          if (player.del && player.groupId > 0) {
            player.groupId = 0;
            savedPlayers.push(player);
          }
          else if (player.groupId > 0) {
            var tee = _this.groups[i].teeBox;

            if (tee === null || tee === '') {
              player.teeBox = '';
            }
            else {
              tee = tee.toUpperCase();
              player.teeBox = tee;
            }

            savedPlayers.push(player);
          }
        }
      }

      _this.saveAll(savedPlayers);
    },
    isEmpty(str) {
      return str===null || str==='' || str==='null';
    },
    assignPlayer(group, player, idx) {
     var _this = this;
     if (group.length < 3 ) {
        switch(idx) {
          case 0:
            player.team = _this.isEmpty(player.team)?'A':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'1':player.ateam;
            break;
          case 1:
            player.team = _this.isEmpty(player.team)?'B':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'2':player.ateam;
            break;
          default: break;
        }
      }
      else {
        switch(idx) {
          case 0:
            player.team = _this.isEmpty(player.team)?'A':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'1':player.ateam;
            break;
          case 1:
            player.team = _this.isEmpty(player.team)?'A':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'2':player.ateam;
            break;
          case 2:
            player.team = _this.isEmpty(player.team)?'B':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'1':player.ateam;
            break;
          case 3:
            player.team = _this.isEmpty(player.team)?'B':player.team;
            player.ateam = _this.isEmpty(player.ateam)?'2':player.ateam;
            break;
          default: break;
        }
      }

      return player;
    },
    async saveAll(players) {
      await this.axios.post('/api/scores/updateGroup/saveAll', players)
          .then(function (response) {
            window.location.reload();
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
          });
    },
    autoGenerate() {
      this.axios.get('/admin/groups/auto-generate/'+this.tournament.tournamentId)
          .then(function (response) {
            window.location.reload();
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
          });
    },
    autoGenerateEW() {
      this.axios.get('/admin/groups/auto-generate3/'+this.tournament.tournamentId)
          .then(function (response) {
            window.location.reload();
          })
          .catch(function (error) {
            console.log('ERROR: ' + error);
          });
    }
  }
}

</script>

<style scoped>

.group-table-card {
  width: 98% !important;
}

.table.b-table>thead>tr>th {
  background-color: white;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}

.card-div {
  display: inline-block;
  margin: 10px;
  width: 95%;
  z-index: 1;
}

.card-div .teebox-input {
  height: 26px;
  width: 50px;
  border: 2px solid white;
  color: white;
  border-radius: 5px;
  margin: 0 20px;
  padding: 2px 7px;
}

@media (min-width: 768px) {
  td {
    font-size: 14px !important;
  }

  .card-div {
    width: 450px !important;
  }

  .main-view {
    display: flex;
  }

  .group-table-card {
    display: inline-block;
    width: 35% !important;
    height: 600px !important;
    overflow-y: scroll;
  }

  .group-cards {
    display: inline-block;
    width: 62% !important;
    margin-left: 20px;
    height: 600px !important;
    overflow-y: scroll;
  }

  .group {
    height: 16px;
    width: 40px;
  }

  .card-div {
    height: 200px;
    vertical-align: top;
  }
}

th {
  text-align: left;
  background-color: #45472e;
  border:1px solid aquamarine;
  box-shadow:2px 2px 1px -1px #000;
  font-size: 16px;
  color: aquamarine;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}

td {
  font-size: 18px;
  color: #2a2b1e;
  border:1px solid rgba(0,0,0,0.4);
  box-shadow:-1px -1px 1px -1px #000;
}

.playerRow:hover {
  cursor: pointer;
  background-color: gold;
}

.action-btn {
  margin-right: 12px;
}

.group {
  padding: 10px;
  border: 2px solid block;
}

.select-btn {
  margin-right: 20px;
  text-align: left;
  background-color: #1867c0;
  width:100%;
  border-radius: 7px;
  padding: 10px;
  color: white;
}

.select-btn:hover {
  cursor: pointer;
}

</style>